import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../context/LangContext";
import { BOOK_PATH, STRINGS } from "../../data/content";

export default function Testimonials({ bg = "off-white", label, title, items, showCta = false }) {
  const { t } = useLang();
  const bgColor = bg === "off-white" ? "var(--off-white)" : "var(--white)";
  return (
    <section className="section" style={{ background: bgColor }}>
      <div className="section-inner">
        {label && (
          <div className="fade-in">
            <div className="section-label">{t(label)}</div>
          </div>
        )}
        <h2 className="section-title fade-in">{t(title)}</h2>
        <div className="t-grid">
          {items.map((item) => (
            <div className="t-card fade-in" key={item.id}>
              <img src={item.img} alt={item.name} className="t-photo" />
              <div className="t-body">
                <div className="t-quote-mark">“</div>
                <p className="t-text">{t(item.quote)}</p>
                <div className="t-footer">
                  <div className="t-name">{item.name}</div>
                  <div className="t-meta">
                    <span className="t-age">{item.age}</span> · <span>{t(item.sport)}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {showCta && (
          <div className="fade-in" style={{ marginTop: 44 }}>
            <Link to={BOOK_PATH} className="btn btn-dark">
              {t(STRINGS.bookCallFree)}
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
